import { jsxs as t, Fragment as l, jsx as r } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ t(l, { children: [
  /* @__PURE__ */ r(
    "path",
    {
      d: "M4 4.25C4 3.00736 5.00736 2 6.25 2H15V6H19.5V19.25C19.5 20.4926 18.4926 21.5 17.25 21.5H6.25C5.00736 21.5 4 20.4926 4 19.25V4.25Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ r(
    "path",
    {
      d: "M18.9138 3.91376C19.2105 4.21053 19.4047 4.59123 19.4728 5H16V2H16.1716C16.702 2 17.2109 2.21094 17.586 2.58601L18.9138 3.91376Z",
      fill: "currentColor"
    }
  )
] });
export {
  o as default
};
